import script from "./SecondIhramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondIhramPage.vue?vue&type=script&setup=true&lang=js"

import "./SecondIhramPage.vue?vue&type=style&index=0&id=2fc810fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc810fc"]])

export default __exports__